// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"105":"dict","177":"home","443":"about"}[chunkId] + "." + {"105":"bddbcc51","177":"ae197dbe","443":"fc04ac4a"}[chunkId] + ".js";
};